module.exports = __webpack_public_path__ + "web/img/img3.708127d6.png";